<script>
    import axios from 'axios';
    import {nextTick} from "vue";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import {store} from "../store";
    import TemplatesLabelCounts from "../../../templates/LabelCounts.vue";
    import Textarea from "primevue/textarea";
    import RadioButton from "primevue/radiobutton";
    import Divider from "primevue/divider";

    export default {
        data() {
            return {
                loading: false,
                list: null,
                error: null,
                limit: 100000,
                model: {targetNode: -2},
                store: store
            }
        },
        props: ["name", "uid", "type"],
        methods: {
            save(){
                let self = this;
                if(this.getData.length === 0){
                    this.error = this.$t('lang.cluster.enter_one_err');
                    return false;
                }

                if(this.getData.length > this.limit){
                    this.error = this.$t('lang.cluster.limit_count_err', [this.limit]);
                    return false;
                }

                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: Object.assign({}, this.model, {keys: self.getData})
                })
                    .then(function (response) {

                        self.loading = false;
                        window.location.reload();

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });


            },
            onClose(){
                this.list = null;
                this.error = null
            },
            onOpen() {
                let self = this;
                nextTick(() => {
                    self.$refs["modalInput"].$el.focus()
                });

                if (this.type === 'import') {
                    this.model = {
                        targetNode: -1,
                    };

                } else {
                    this.model = {
                        targetNode: -2,
                    };

                }

            }
        },
        computed: {
            getSelectNode() {
                return this.store.getters.selectNode();
            },
            getApiUrl() {
                return this.$config.API_URL + '/clustering/' + this.uid + '/' + this.type + '/list' ;
            },
            getData() {
                if (this.list) {
                    return this.list.replace(/\r\n/g,"\n").split("\n").filter(item => item !== "");
                }
                return [];
            },
            btnModalLabel() {
                return this.type === 'import' ? this.$t('lang.main.btn.add') : this.$t('lang.main.btn.delete');
            },
            count() {
                return this.getData.length;
            }
        },
        components: {
            TemplatesLabelCounts,
            AdaptersDialog,
            Textarea,
            RadioButton,
            Divider,
        },
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="name"
        :header="$t('lang.cluster.keys_list')"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :loading="loading"
        :error-message="error"
        :button-agree-label="btnModalLabel"
        :callback-agree="save"
    >
        <template #content>
            <div class="field">
                <TemplatesLabelCounts :text="$t('lang.cluster.tmpl_keys_rules')" :count="count" :limit="limit" />
                <Textarea v-model="list" rows="16" ref="modalInput" />
            </div>
            <Divider />
            <div class="formgroup-inline">
                <label>{{ $t('lang.cluster.select_folder') }}</label>
                <div v-if="type === 'delete'" class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_deleted"
                        name="targetNode"
                        :value="-2"
                    />
                    <label for="f_deleted">{{ $t('lang.cluster.f_deleted') }}</label>
                </div>
                <div v-else-if="getSelectNode.id > 0" class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_current"
                        name="targetNode"
                        :value="getSelectNode.id"
                    />
                    <label for="f_current">{{ $t('lang.cluster.f_current', [getSelectNode.name]) }}</label>
                </div>
                <div class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_unallocated"
                        name="targetNode"
                        :value="-1"
                    />
                    <label for="f_unallocated">{{ $t('lang.cluster.f_unallocated') }}</label>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>
